import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICheckboxRadioChoice } from '@shared/models/interfaces/check-radio-choice.interface';
import { FormField } from '@shared/components/form/models/beans/form-field.abstract';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { getControl } from '@shared/helpers/form.helper';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'checkboxfield',
    templateUrl: './checkboxfield.component.html',
    styleUrls: ['./checkboxfield.component.scss'],
})
export class CheckboxfieldComponent extends FormField implements OnInit {
    @Input() choices: ICheckboxRadioChoice[];
    @Input() enableChangeListener = false;
    @Output() onchange = new EventEmitter();

    private _subs = new Subscription();
    constructor() {
        super();
    }

    ngOnInit(): void {
        if (this.form && this.enableChangeListener && (this.fieldControl || !isNilOrEmpty(this.fieldName))) {
            const targetControl = this.fieldControl || getControl(this.form, this.fieldName);
            this._subs.add(
                targetControl?.valueChanges.pipe(filter((value) => !!value)).subscribe((value) => {
                    this.onchange.emit(value);
                })
            );
        }
    }
}
